<div class="flex flex-auto">
  <mat-drawer-container>
    <mat-drawer [mode]="drawerMode" [opened]="false" [position]="'end'" [disableClose]="false" #matDrawer>
      <router-outlet></router-outlet>
    </mat-drawer>
    <mat-drawer-content class="flex flex-col inset-0 absolute">
      <ng-container *ngIf="loanRequest; else NoLoanRequets">
        <!-- Header -->
        <div class="header">
          <!-- Toolbar -->
          <div class="toolbar">
            <div class="info flex flex-col">
              <!-- Subject -->
              <div class="flex flex-row">
                <div class="subject">
                  {{ loanRequest.description }}
                </div>
                <div>
                  <button
                    mat-icon-button
                    (click)="editLoanRequest()"
                    matTooltip="Edit Loan Request"
                    [appAuthorize]="NewPermission.LOAN_QUOTES_EDIT"
                  >
                    <mat-icon [svgIcon]="'edit'" class="icon-size-20"></mat-icon>
                  </button>
                  <button mat-icon-button (click)="export()" matTooltip="Export as CSV">
                    <mat-icon>save_alt</mat-icon>
                  </button>
                  <button
                    class="today lt-md:hidden"
                    mat-icon-button
                    (click)="openFieldDefsPanel()"
                    matTooltip="Select Fields to Display"
                    #fieldDefsPanelOrigin
                  >
                    <mat-icon [svgIcon]="'visibility'"></mat-icon>
                  </button>
                  <ng-template #fieldDefsPanel>
                    <div class="contacts-details-tags-panel">
                      <div class="tags-panel-header">
                        <div class="new-tag">
                          <mat-icon [svgIcon]="'search'"></mat-icon>
                          <input
                            type="text"
                            placeholder="Enter field name"
                            (input)="filterFields($event)"
                            (keydown)="filterFieldsInputKeyDown($event)"
                            [maxLength]="50"
                            #newTagInput
                          />
                        </div>
                      </div>

                      <div class="available-tags">
                        <ng-container>
                          <mat-checkbox
                            *ngFor="let fieldDef of filteredFieldDefs; trackBy: trackByFn"
                            [color]="'primary'"
                            [checked]="displayColumns.includes(fieldDef.name)"
                            (change)="toggleDisplayColumn(fieldDef.name, $event)"
                          >
                            {{ fieldDef.label }}
                          </mat-checkbox>
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="excerpt">{{ loanRequest.loan_purpose?.name }}</div>
            </div>

            <div class="mr-4">
              <!-- Other actions button & menu -->
              <button
                class="add-contact"
                mat-flat-button
                [color]="'primary'"
                (click)="addLoanQuote()"
                [matTooltip]="'Add'"
                [appAuthorize]="NewPermission.LOAN_QUOTES_CREATE"
                denyAction="disable"
              >
                <mat-icon [svgIcon]="'add'"></mat-icon>
                Add
              </button>
              <button
                class="more-menu"
                mat-icon-button
                [matMenuTriggerFor]="moreMenu"
                [appAuthorize]="NewPermission.LOAN_QUOTES_DELETE"
              >
                <mat-icon [svgIcon]="'more_vert'"></mat-icon>
              </button>

              <mat-menu #moreMenu="matMenu">
                <button mat-menu-item (click)="deleteLoanRequest()">
                  <mat-icon [svgIcon]="'delete'"></mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>

        <!-- Threads -->
        <div class="threads">
          <!-- Thread -->
          <div class="quotes-list">
            <div class="table-wrapper">
              <div class="inline-table-wrapper">
                <!-- Table -->
                <table
                  mat-table
                  matSort
                  [matSortActive]="'rate'"
                  [matSortDisableClear]="true"
                  [matSortDirection]="'asc'"
                  [dataSource]="loanQuotesDataSource"
                  [trackBy]="trackByFn"
                  class="table-container"
                  cdkDropList
                  cdkDropListOrientation="horizontal"
                  (cdkDropListDropped)="dropColumns($event)"
                >
                  <div
                    class="flex flex-col gt-xs:flex-row"
                    [matColumnDef]="column"
                    *ngFor="let column of displayColumns"
                  >
                    <ng-container *ngIf="lookupField(column) as fieldDef">
                      <th
                        class="loan-quote-header bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                        mat-header-cell
                        mat-sort-header
                        *matHeaderCellDef
                        cdkDrag
                        cdkDragBoundary=".table-container"
                        cdkDragLockAxis="x"
                      >
                        <div class="drag-handle" cdkDragHandle>
                          <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                        </div>
                        <span class="whitespace-no-wrap">
                          {{ fieldDef.label }}
                        </span>
                      </th>
                      <td tsFocusBgColor mat-cell *matCellDef="let loanQuote">
                        @switch (fieldDef.name) {
                          @case ('workflow_state') {
                            <task-status
                              [task]="loanQuote"
                              [taskStatuses]="workflowStates"
                              (onUpdate)="updateLoanQuote(loanQuote)"
                              [readonly]="!canEditLoanQuote()"
                            />
                          }
                          @case ('lender_company') {
                            @if ('loanQuote.lender') {
                              <div tabindex="0" class="flex flex-col" (click)="openContactModal(loanQuote)">
                                <span>
                                  {{ loanQuote.lender?.company_name }}
                                </span>
                              </div>
                            }
                          }
                          @case ('lender') {
                            @if (loanQuote?.lender) {
                              <div class="flex flex-row">
                                <span class="underline">
                                  <a [routerLink]="'/contacts/' + [loanQuote.lender.id]">{{ loanQuote.lender.name }}</a>
                                </span>
                                <button
                                  class="complete-task -mt-2"
                                  mat-icon-button
                                  (click)="openContactModal(loanQuote)"
                                  [disabled]="!canEditLoanQuote()"
                                >
                                  <mat-icon [svgIcon]="'edit'" class="icon-size-20"></mat-icon>
                                </button>
                              </div>
                            } @else {
                              <div>
                                <button
                                  (click)="openContactModal(loanQuote)"
                                  class="underline"
                                  [disabled]="!canEditLoanQuote()"
                                >
                                  Select Lender
                                </button>
                              </div>
                            }
                          }
                          @default {
                            <app-editable
                              [fieldDef]="fieldDef"
                              [model]="loanQuote"
                              [readonly]="!canEditLoanQuote()"
                              (onUpdate)="onUpdateLoanQuote($event, loanQuote, true)"
                            />
                          }
                        }
                      </td>
                    </ng-container>
                  </div>

                  <ng-container matColumnDef="delete">
                    <th
                      mat-header-cell
                      mat-sort-header
                      *matHeaderCellDef
                      class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                    ></th>
                    <td mat-cell *matCellDef="let loanQuote">
                      <a [routerLink]="[loanQuote.id]" class="placeholder">
                        <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
                      </a>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="loanQuotesTableColumns"></tr>
                  <tr class="quote-row" mat-row *matRowDef="let row; columns: loanQuotesTableColumns"></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #NoLoanRequets>
        <div class="no-loan-requets">
          <mat-icon [svgIcon]="'iconsmind:mailbox_empty'"></mat-icon>
          <h4>There are no loan requests</h4>
        </div>
      </ng-template>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
